import * as React from 'react';

import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { ListItem } from './ListItem/ListItem';

const SortableItem = SortableElement(ListItem);

const SortableList = ({ items, onHideClick }) => {
	return (
		<div>
			{items.map((item, index) => (
				<SortableItem
					key={item.id}
					index={index}
					order={index}
					data={item}
					onHideClick={onHideClick}
					disabled={item.hidden}
				/>
			))}
		</div>
	);
};

export default SortableContainer(SortableList);
